var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmAlerts = function SvgBmAlerts(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.698 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.16 -195.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-81.61,210.279h-.306v-3.667a4.278,4.278,0,0,0-3.056-4.1v-.791a1.222,1.222,0,0,0-1.222-1.222,1.222,1.222,0,0,0-1.222,1.222v.791a4.278,4.278,0,0,0-3.056,4.1v3.667h-.306A1.222,1.222,0,0,0-92,211.5a1.222,1.222,0,0,0,1.222,1.222h9.168a1.222,1.222,0,0,0,1.222-1.222A1.222,1.222,0,0,0-81.61,210.279Z",
    transform: "translate(-1.618 -2.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-73.079,199.277a9.718,9.718,0,0,0-5.647-4.206.611.611,0,0,0-.752.427.612.612,0,0,0,.427.752,8.5,8.5,0,0,1,4.938,3.679.61.61,0,0,0,.518.285.609.609,0,0,0,.325-.094A.611.611,0,0,0-73.079,199.277Z",
    transform: "translate(-6.478 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-89.667,195.5a.611.611,0,0,0-.752-.427,9.718,9.718,0,0,0-5.647,4.206.611.611,0,0,0,.191.843.609.609,0,0,0,.325.094.61.61,0,0,0,.518-.285,8.5,8.5,0,0,1,4.938-3.679A.612.612,0,0,0-89.667,195.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-91.876,200.774a.61.61,0,0,0,.114.856.6.6,0,0,0,.37.126.609.609,0,0,0,.486-.24,5.909,5.909,0,0,1,3.049-2.087.612.612,0,0,0,.415-.758.612.612,0,0,0-.758-.415A7.122,7.122,0,0,0-91.876,200.774Z",
    transform: "translate(-1.617 -1.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-80.061,199.429a5.909,5.909,0,0,1,3.049,2.087.609.609,0,0,0,.486.24.6.6,0,0,0,.37-.126.61.61,0,0,0,.114-.856,7.122,7.122,0,0,0-3.676-2.518.613.613,0,0,0-.758.415A.612.612,0,0,0-80.061,199.429Z",
    transform: "translate(-6.089 -1.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-83.666,223.334a1.833,1.833,0,0,0,1.834-1.834H-85.5A1.833,1.833,0,0,0-83.666,223.334Z",
    transform: "translate(-4.145 -10.284)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmAlerts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Alerts.6f6b91c7.svg";
export { ForwardRef as ReactComponent };